import { render, staticRenderFns } from "./beijingDoctorCourseNew.vue?vue&type=template&id=2ea9427c&scoped=true"
import script from "./beijingDoctorCourseNew.vue?vue&type=script&lang=js"
export * from "./beijingDoctorCourseNew.vue?vue&type=script&lang=js"
import style0 from "./beijingDoctorCourseNew.vue?vue&type=style&index=0&id=2ea9427c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea9427c",
  null
  
)

export default component.exports